import { CatTableHeaderCell } from 'blocks-nextjs/blocks-react/components/TableHeaderCell';
import { useTranslations } from 'next-intl';

export const PartsTableTitles = () => {
  const t = useTranslations();

  return (
    <>
      <CatTableHeaderCell>{t('QUANTITY1')}</CatTableHeaderCell>
      <CatTableHeaderCell>
        {t('CPG_PRODUCT_IMAGE')}
      </CatTableHeaderCell>
      <CatTableHeaderCell>
        <span>{t('CAT_CONTACT_YOUR_DEALER_PRODUCT_NUMBER')}</span>
      </CatTableHeaderCell>
      <CatTableHeaderCell>
        <span>{t('PDP_AVAILBLE_FOR_PICKUP')}</span>
      </CatTableHeaderCell>
      <CatTableHeaderCell >
        <span>{t('TOTAL_PRICE')}</span>
      </CatTableHeaderCell>
      <CatTableHeaderCell>
        <span>{''}</span>
      </CatTableHeaderCell>
    </>
  );
};
